var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-component",attrs:{"id":"footer"}},[_c('div',[_vm._v("Copyright © GorAlex "+_vm._s(_vm.currentYear))])])}
var staticRenderFns = []

export { render, staticRenderFns }